var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-left do-it" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/scoring-events" } },
                    [
                      _c("b-card", {
                        attrs: {
                          overlay: "",
                          "img-src": "/static/Grow-red.png",
                          title: "Analyse Scoring Events",
                          "text-variant": "white"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-left do-it align-text-bottom" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/industry-data" } },
                    [
                      _c("b-card", {
                        attrs: {
                          overlay: "",
                          "img-src": "/static/Think-red.png",
                          title: "Explore Industry Data",
                          "text-variant": "white"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "pt-3" },
            [
              _c(
                "b-col",
                { staticClass: "text-right do-it" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/wizard" } },
                    [
                      _c("b-card", {
                        attrs: {
                          overlay: "",
                          "img-src": "/static/Ruler-red.png",
                          title: "Import New Data",
                          "text-variant": "white"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "text-right do-it" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: "/gpc-sessions" } },
                    [
                      _c("b-card", {
                        attrs: {
                          overlay: "",
                          "img-src": "/static/Spanner-red.png",
                          title: "Dig into the Detail",
                          "text-variant": "white"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fae5bece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fae5bece","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 